import { Position, Toaster, Classes } from '@blueprintjs/core';
import './styles.css'; 

export const ClinicFormToaster = (typeof window !== 'undefined') ? Toaster.create({
    className: "success-toaster",
    position: Position.TOP,
    intent: Classes.INTENT_SUCCESS
}) : null;
